import { z } from "zod"

export const artistApplyDto = z.object({
  email: z.string({ required_error: "Bitte geben Sie eine E-Mail an" }).email("Bitte geben Sie eine gültige E-Mail Adresse ein"),
  socialMediaOrWebsite: z.string({ required_error: "Bitte geben Sie Ihren Social Media Namen oder eine Website an" }),
})
